<template>
<v-container v-if="$store.getters.restricted==='yes'" style="margin-top: 20%;">
    <v-row align="center">
        <v-col align="center" cols="12">
            <v-card>
                <v-card-title>
                    Please enter site password
                </v-card-title>
                <v-card-text>
                    <v-text-field type="password" outlined label="Password" v-model="form.password" @keydown.enter="checkPassword"/>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                        <v-btn color="primary" :disabled="form.password===null || form.password.length==0" @click="checkPassword">
                            Submit
                        </v-btn>
                    <v-spacer/>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</v-container>
</template>

<script>
import cache from '@/plugins/cache.js'

export default {
    created: function(){
        let siteBlocker = cache.storage.local.get('siteBlocker')
        if ((siteBlocker===null || siteBlocker==='yes') && process.env.VUE_APP_ENV!=='local'){
            this.$store.commit('restricted', 'yes')
        }
    },
    data: function(){
        return {
            form: {
                password: null
            },
            code: 'M0unt!an',
            pass: false
        }
    },
    methods: {
        checkPassword: function(){
            this.pass = this.form.password!=null && this.form.password.length>0 && this.form.password==this.code
            this.$store.commit('restricted', this.pass===true ? 'no' : 'yes')
            cache.storage.local.set('restricted', this.pass===true ? 'no' : 'yes')
        }
    }
}
</script>

<style>

</style>